const Builder = require('../BuilderBase');

module.exports = class PageAccess extends Builder {
    constructor(title, properties) {
        super('formElement_PageAccess', title, properties);
    }
};
